'use strict'
import _ from 'lodash'
import fidelity from '@/services/fidelityService.js'
import escpos from '@/services/escposService.js'
import stampante from '@/services/stampanteService.js'
/* import moment from 'moment'
import stampante from '@/services/stampanteService.js'
import contabili from '@/services/contabiliService.js' */

const stampaBuonoRiscattato = async (context, card, buono) => {
  const scontrinoInfo = JSON.parse(JSON.stringify(_.get(buono, 'stampa.scontrino', [])))
  const scontrinoComandi = JSON.parse(JSON.stringify(_.get(buono, 'stampa.scontrinoComandi', [])))
  const valoreCoupon = buono.importo
  const dataLimite = buono.dataLimite
  const spesaMinima = buono.riscatto.spesaMinima || 0
  const limite = buono.puntiMinimi
  const puntiMinimi = buono.puntiMinimi
  const puntiMassimi = buono.puntiMassimi
  const puntiTotali = card.raccoltaPunti.totale
  const puntiResidui = card.raccoltaPunti.totale
  const tipoStampa = _.get(buono, 'stampa.tipoStampa', 'coupon')
  let barcode = null
  var coupon
  if (scontrinoInfo.length > 0) {
    try {
      for (let i = 0; i < scontrinoInfo.length; i++) {
        scontrinoInfo[i] = scontrinoInfo[i].replace('#cliente#', card.cliente.ragioneSociale)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#codice_cliente#', card.cliente.codice)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#fidelity#', card.codice)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#punti#', limite)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#puntiMinimi#', puntiMinimi)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#puntiMassimi#', puntiMassimi)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#valore#', valoreCoupon)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#punti_totali#', puntiTotali)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#punti_residui#', puntiResidui)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#dataLimite#', dataLimite)
        scontrinoInfo[i] = scontrinoInfo[i].replace('#spesaMinima#', spesaMinima)
      }
      if (_.get(buono, 'stampa.barcodeSuScontrino', false)) {
        barcode = {
          code: card.codice
        }
      }
      if (tipoStampa === 'coupon') {
        const idCassa = context.impostazioni.stampante.progressivo_stampante
        const applicaA = _.get(buono, 'stampa.coupon.applicaA', 'subtotale')
        coupon = await fidelity.creaCoupon(idCassa, valoreCoupon, applicaA, spesaMinima)
        if (barcode) {
          barcode.code = coupon.codice
        }
        const tipoStampante = _.get(buono, 'stampa.coupon.tipoStampante', 'fiscale')
        if (tipoStampante === 'fiscale') {
          await stampante.stampaScontrinoGestionale(scontrinoInfo, barcode)
        } else {
          await escpos.stampaCoupon(scontrinoInfo, barcode)
        }
      } else {
        await stampante.stampaScontrinoGestionale(scontrinoInfo, barcode)
      }
    } catch (err) {
      console.log(err)
    }
  }

  if (scontrinoComandi.length > 0) { // in questo caso solo su Stampante ESCPOS --> comande
    try {
      if (tipoStampa === 'coupon') {
        // crea il coupon come fidelity card e associa numero
        const idCassa = context.impostazioni.stampante.progressivo_stampante
        const applicaA = _.get(buono, 'stampa.coupon.applicaA', 'subtotale')
        coupon = await fidelity.creaCoupon(idCassa, valoreCoupon, applicaA)
      }
      for (let i = 0; i < scontrinoComandi.length; i++) {
        scontrinoComandi[i].v1 = String(scontrinoComandi[i].v1).replace('#cliente#', card.cliente.ragioneSociale)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#codice_cliente#', card.cliente.codice)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#fidelity#', card.codice)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#punti#', limite)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#puntiMinimi#', puntiMinimi)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#puntiMassimi#', puntiMassimi)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#valore#', valoreCoupon)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#punti_totali#', puntiTotali)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#punti_residui#', puntiResidui)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#dataLimite#', dataLimite)
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#spesaMinima#', spesaMinima)
        // TODO: EAN13 deve passare 12 char, verificare per altri
        scontrinoComandi[i].v1 = scontrinoComandi[i].v1.replace('#barcode#', coupon.codice.substring(0, 12))
      }
      if (tipoStampa === 'coupon') {
        const tipoStampante = _.get(buono, 'stampa.coupon.tipoStampante', 'fiscale')
        if (tipoStampante === 'comande') {
          await escpos.stampaCouponComandi(scontrinoComandi)
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
}

export default {
  stampaBuonoRiscattato
}
